import { render, staticRenderFns } from "./GLManagement.vue?vue&type=template&id=1b112796"
import script from "./GLManagement.vue?vue&type=script&lang=js"
export * from "./GLManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports